import { Component, Input } from '@angular/core';
import { NotificationsEntity } from '@qwyk/portals/data-access/notifications';

@Component({
    selector: 'qwyk-notification-detail',
    templateUrl: './notification-detail.component.html',
    styleUrls: ['./notification-detail.component.css'],
})
export class NotificationDetailComponent {
    @Input() notification: NotificationsEntity;
}
